import { Crown, Users, GraduationCap, BarChart3, Send, MessageSquareQuote, Bot } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { UsersPanel, QuizAdminPanel } from "./AreaComando";
import ExecutiveStatsPanel from "../components/ExecutiveStatsPanel";
import DiscordInvitesPanel from "../components/DiscordInvitesPanel";
import FeedbackManagerPanel from "../components/FeedbackManagerPanel";
import BotControlPanel from "../components/BotControlPanel";

export default function AreaEsecutiva() {
  return (
    <div className="space-y-8" data-testid="area-esecutiva">
      <div>
        <div className="uppercase-label text-sheriff-gold mb-2 flex items-center gap-2">
          <Crown className="h-4 w-4" /> Area Esecutiva
        </div>
        <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tighter text-[#F5E6B8]">
          Pannello di Controllo Supremo
        </h1>
        <p className="text-[#D4C480] max-w-2xl mt-2">
          Funzioni riservate al <span className="text-sheriff-gold font-semibold">Staff Esecutivo</span>
          (Sceriffo · Sotto Sceriffo · Assistente Sceriffo): statistiche di comando,
          amministrazione utenti, gestione esami di promozione, feedback operatori, controllo bot Discord.
        </p>
      </div>

      <Tabs defaultValue="stats" className="w-full">
        <TabsList className="bg-[#143830] border border-sheriff-gold/25 rounded-xl flex-wrap h-auto">
          <TabsTrigger value="stats" data-testid="tab-executive-stats" className="rounded-xl uppercase-label">
            <BarChart3 className="h-4 w-4 mr-2" /> Gestione
          </TabsTrigger>
          <TabsTrigger value="users" data-testid="tab-users" className="rounded-xl uppercase-label">
            <Users className="h-4 w-4 mr-2" /> Utenti & Permessi
          </TabsTrigger>
          <TabsTrigger value="quiz" data-testid="tab-quiz-admin" className="rounded-xl uppercase-label">
            <GraduationCap className="h-4 w-4 mr-2" /> Esami Promozione
          </TabsTrigger>
          <TabsTrigger value="feedback" data-testid="tab-feedback-manager" className="rounded-xl uppercase-label">
            <MessageSquareQuote className="h-4 w-4 mr-2" /> Feedback
          </TabsTrigger>
          <TabsTrigger value="invites" data-testid="tab-discord-invites" className="rounded-xl uppercase-label">
            <Send className="h-4 w-4 mr-2" /> Inviti Discord
          </TabsTrigger>
          <TabsTrigger value="bot" data-testid="tab-bot-control" className="rounded-xl uppercase-label">
            <Bot className="h-4 w-4 mr-2" /> Bot Discord
          </TabsTrigger>
        </TabsList>
        <TabsContent value="stats" className="mt-6">
          <ExecutiveStatsPanel />
        </TabsContent>
        <TabsContent value="users" className="mt-6">
          <UsersPanel />
        </TabsContent>
        <TabsContent value="quiz" className="mt-6">
          <QuizAdminPanel />
        </TabsContent>
        <TabsContent value="feedback" className="mt-6">
          <FeedbackManagerPanel />
        </TabsContent>
        <TabsContent value="invites" className="mt-6">
          <DiscordInvitesPanel />
        </TabsContent>
        <TabsContent value="bot" className="mt-6">
          <BotControlPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
